module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAENSURBVEhL5dU9agJRFIbhi1WIVawlhZUGLE1lIVYuQcQiu0gj2CRdFmDnAtKkCSQbsLRxDWrpX2WVvEfmwEHmOHONlfngYc6M936XgQHDv8xP4qKxpXbe4yKHeQfY+U/xSr05Ol6RN0fHK/Lm6HhF3hwdr8ibo6Ob8zgraUWezNygmVw1xyWvKKKFTfJMZeYbsnCOrjwguvkTdRSg6WOJ3AeMoYvFl5nLkMgb7PByuAvhEbomM7eYQTdYD5BIudzLVVKCrsmVKrTEeobk+A3eoGtypwdbLoZIywK6Jioj2APki3lCGx3cYQD7e1TkU53CHnLKO6JTwRpphdYK9zgrDUyg/2DWFh+o4eoSwi9ws6tkWchKJQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-garden-gloves/dark/24.png
// module id = 2102
// module chunks = 2